import { CALL_API } from '../middleware/api'

// Fetch SAT notification settings (singleton)
export const NOTIFICATION_SETTINGS_REQUEST = 'NOTIFICATION_SETTINGS_REQUEST'
export const NOTIFICATION_SETTINGS_SUCCESS = 'NOTIFICATION_SETTINGS_SUCCESS'
export const NOTIFICATION_SETTINGS_FAILURE = 'NOTIFICATION_SETTINGS_FAILURE'

export function fetchNotificationSettings() {
  return {
    [CALL_API]: {
      method: 'GET',
      endpoint: 'notificationsettings',
      authenticated: true,
      types: [NOTIFICATION_SETTINGS_REQUEST, NOTIFICATION_SETTINGS_SUCCESS, NOTIFICATION_SETTINGS_FAILURE]
    }
  }
}

// Update SAT notification settings
export const NOTIFICATION_SETTINGS_UPDATE_REQUEST = 'NOTIFICATION_SETTINGS_UPDATE_REQUEST'
export const NOTIFICATION_SETTINGS_UPDATE_SUCCESS = 'NOTIFICATION_SETTINGS_UPDATE_SUCCESS'
export const NOTIFICATION_SETTINGS_UPDATE_FAILURE = 'NOTIFICATION_SETTINGS_UPDATE_FAILURE'

export function updateNotificationSettings(settings) {
  return {
    [CALL_API]: {
      method: 'PUT',
      endpoint: 'notificationsettings',
      authenticated: true,
      body: JSON.stringify(settings),
      types: [NOTIFICATION_SETTINGS_UPDATE_REQUEST, NOTIFICATION_SETTINGS_UPDATE_SUCCESS, NOTIFICATION_SETTINGS_UPDATE_FAILURE]
    }
  }
}
